import { color } from "@styles";
import { FormLoadingSpinner } from "components/atoms/Form/FormLoadingSpinner";
import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";

interface QuoteSubmitrops extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  value: string;
  isInputValid?: boolean;
}

export const QuoteSubmit = ({ loading, value, isInputValid, ...rest }: QuoteSubmitrops) => {
  return (
    <QuoteSubmitButton isLoading={loading} isInputValid={isInputValid} disabled={loading} {...rest}>
      {loading ? (
        <>
          <FormLoadingSpinner size="30px" /> Loading...
        </>
      ) : (
        value
      )}
    </QuoteSubmitButton>
  );
};

const QuoteSubmitButton = styled.button<{ isInputValid?: boolean; isLoading: boolean }>`
  width: 100%;
  margin: 1rem 0;
  border: none;
  box-sizing: border-box;
  padding: 1rem 1.25rem;
  font-weight: bold;
  font-size: 1.25rem;
  letter-spacing: 0.05rem;
  color: ${color.B1100};
  background: ${(p) => (p.isLoading ? "#e30d76bb" : color.P100)};
  border-radius: 0.5rem;
  cursor: ${(p) => (p.isLoading ? "not-allowed" : "pointer")};
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(p) =>
    p.isInputValid ? null : `animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both`};

  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;

  transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);

  &:hover {
    background-color: #e30d76bb;
  }

  &:focus {
    background-color: #e30d76bb;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;
